import { render, staticRenderFns } from "./WorkCenterMonitor.vue?vue&type=template&id=ded72a2c"
import script from "./WorkCenterMonitor.vue?vue&type=script&lang=js"
export * from "./WorkCenterMonitor.vue?vue&type=script&lang=js"
import style0 from "./WorkCenterMonitor.vue?vue&type=style&index=0&id=ded72a2c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ded72a2c')) {
      api.createRecord('ded72a2c', component.options)
    } else {
      api.reload('ded72a2c', component.options)
    }
    module.hot.accept("./WorkCenterMonitor.vue?vue&type=template&id=ded72a2c", function () {
      api.rerender('ded72a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/WorkCenterMonitor.vue"
export default component.exports